// extracted by mini-css-extract-plugin
export const list = "vendors-list-module--list--2seRE";
export const listGroup = "vendors-list-module--list-group--381wg";